import React from "react";

export default function AccountDeletion() {
  return (
    <div
      style={{
        maxWidth: 860,
        margin: "32px auto",
        padding: 24,
        fontFamily: "system-ui, Segoe UI, Roboto, Helvetica",
      }}
    >
      <h1>Delete your Rupioo account & data</h1>
      <p>
        You can request deletion of your account and associated data at any
        time. Deletion is permanent and cannot be undone.
      </p>
      <h2>How to request deletion</h2>
      Send an email from your registered address to
      <a href="mailto:rupioobrain@gmail.com?subject=Delete%20my%20Rupioo%20account">
        {" "}
        rupioobrain@gmail.com
      </a>{" "}
      with subject “Delete my Rupioo account”. Include your registered email and
      this text: “I confirm I want my account deleted.”
      <h2>What we delete</h2>
      <ul>
        <li>Account profile (email, phone)</li>
        <li>Tasks, texts/notes, documents metadata</li>
        <li>Forms and responses you own</li>
        <li>Authentication tokens and usage counters</li>
      </ul>
      <h2>What may be temporarily retained</h2>
      <ul>
        <li>
          Server logs and payment records kept up to 90 days for
          security/fraud/legal compliance
        </li>
      </ul>
      <h2>Timeline</h2>
      <p>
        We process deletions within 7 days. You’ll receive a confirmation email
        when completed.
      </p>
      <h2>Need help?</h2>
      <p>
        Email <a href="mailto:rupioobrain@gmail.com">rupioobrain@gmail.com</a>.
      </p>
    </div>
  );
}
